import { gql } from 'apollo-boost'

const RESOLVE_MENU_SCRAPING_TASK = gql`
  mutation resolveMenuScrapingTask(
    $id: ID!
    $menuData: SaveMenuScrapingTaskMenuInput!
    $menuChangeDetectionSettingsData: SaveMenuChangeDetectionSettingsInput!
    $menuDocumentFilesData: [MenuScrapingTaskMenuDocumentFileInput!]
    $isDebugModeScraping: Boolean!
    $isDefaultScrapingEngine: Boolean!
  ) {
    resolveMenuScrapingTask(
      id: $id
      menuData: $menuData
      menuChangeDetectionSettingsData: $menuChangeDetectionSettingsData
      menuDocumentFilesData: $menuDocumentFilesData
      isDebugModeScraping: $isDebugModeScraping
      isDefaultScrapingEngine: $isDefaultScrapingEngine
    ) {
      id
    }
  }
`

export default RESOLVE_MENU_SCRAPING_TASK
